import {Image} from '@shopify/hydrogen';
import type {MediaEdge} from '@shopify/hydrogen/storefront-api-types';
import type {MediaImage} from '@shopify/hydrogen/storefront-api-types';
import {Swiper, SwiperSlide} from 'swiper/react';

import {Navigation, Thumbs, Zoom} from 'swiper/modules';
import {useState} from 'react';
/**
 * A client component that defines a media gallery for hosting images, 3D models, and videos of products
 */

export function ProductGallery({
  media,
  showMainGallery = true,
}: {
  media: MediaEdge['node'][];
  className?: string;
  showMainGallery?: boolean;
}) {
  if (!media.length) {
    return null;
  }

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <>
      {showMainGallery ? (
        <Swiper
          spaceBetween={10}
          navigation={true}
          zoom={true}
          thumbs={{
            swiper:
              thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
          }}
          modules={[Navigation, Thumbs, Zoom]}
          className="products-details-image"
        >
          {media.map((med, i) => {
            const isFirst = i === 0;
            const isFourth = i === 3;
            const isFullWidth = i % 3 === 0;

            const data = {
              ...med,
              image: {
                // @ts-ignore
                ...med.image,
                altText: med.alt || 'Product image',
              },
            } as MediaImage;

            return (
              <SwiperSlide
                // @ts-ignore
                key={`${
                  med.id || med.image.id
                }-${i}-${isFirst}-main-${new Date().toDateString()}`}
              >
                <div className="single-image-box">
                  {(med as MediaImage).image && (
                    <Image
                      loading={i === 0 ? 'eager' : 'lazy'}
                      data={data.image!}
                      aspectRatio={undefined}
                      sizes={
                        isFirst || isFourth
                          ? '(min-width: 48em) 60vw, 90vw'
                          : '(min-width: 48em) 30vw, 90vw'
                      }
                      className="object-cover w-full h-full aspect-square fadeIn"
                    />
                  )}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : null}

      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        navigation={true}
        watchSlidesProgress={true}
        modules={[Navigation, Thumbs]}
        className="products-details-image product-thumb"
      >
        {media.map((med, i) => {
          const isFirst = i === 0;
          const isFourth = i === 3;
          const isFullWidth = i % 3 === 0;

          const data = {
            ...med,
            image: {
              // @ts-ignore
              ...med.image,
              altText: med.alt || 'Product image',
            },
          } as MediaImage;

          return (
            <SwiperSlide
              // @ts-ignore
              key={`${
                med.id || med.image.id
              }-${i}-${isFirst}-thumbnail-${new Date().toDateString()}`}
            >
              <div className="single-image-box">
                {(med as MediaImage).image && (
                  <Image
                    loading={i === 0 ? 'eager' : 'lazy'}
                    data={data.image!}
                    aspectRatio={undefined}
                    sizes={
                      isFirst || isFourth
                        ? '(min-width: 48em) 60vw, 90vw'
                        : '(min-width: 48em) 30vw, 90vw'
                    }
                    className="object-cover w-full h-full aspect-square fadeIn"
                  />
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
}
